<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Cotizaciones
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Cotizaciones
        v-card(color='', style="border-radius:5px;background-color: white; padding: 16px;")
          v-layout(row wrap)
            v-flex(xs12 sm6 md4 style='padding: 0 8px;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
            v-flex(xs12 sm6 md4 style='padding: 0 8px;')
              v-select(outline v-model='filtroStatus' :items='statusOpciones' label='Estatus' item-text='text' item-value='value')
            v-flex(xs12 sm6 md4 style='padding: 0 8px;')
              v-select(outline v-model='filtroVendedor' :items='vendedoresOpciones' label='Vendedor' item-text='text' item-value='value')
          v-layout(row wrap style='padding: 0 8px 16px;')
            v-flex(xs12 sm6 md3)
              v-text-field(outline v-model='busqueda' label='Buscar (nro, cliente, vendedor)' append-icon='search' @keyup.enter='buscar')
            v-flex(xs12 sm6 md3 style='display:flex; align-items:center; padding-left:8px;')
              v-btn(style='background:#ff6500; border-radius:10px; color:white;' @click='buscar' :loading='loading').elevation-4
                v-icon search
                | &nbsp;Buscar
              v-btn(style='background:#424242; border-radius:10px; color:white; margin-left:8px;' @click='limpiar').elevation-4
                v-icon refresh
                | &nbsp;Limpiar

        v-card(color='' style='border-radius:5px; background-color:white; margin-top:4px;')
          v-card-text
            div(v-if='loading' style='display:flex; justify-content:center; padding:40px;')
              v-progress-circular(indeterminate color='primary')
            div(v-else-if='resultados.length === 0' style='text-align:center; padding:40px; color:#9e9e9e;')
              v-icon(size='64' color='grey lighten-2') description
              p(style='margin-top:16px;') No se encontraron cotizaciones
            v-data-table(
              v-else
              :headers='headers'
              :items='resultados'
              :rows-per-page-items='[15, 25, 50]'
              rows-per-page-text='Filas por página'
              no-data-text='Sin resultados'
            )
              template(v-slot:items='props')
                td {{ props.item.doc_num ? props.item.doc_num.trim() : '-' }}
                td {{ props.item.fec_emis | moment('DD/MM/YYYY') }}
                td {{ props.item.cliente || '-' }}
                td {{ props.item.vendedor ? props.item.vendedor.trim() : '-' }}
                td
                  v-chip(:color='statusColor(props.item.status)' text-color='white' small)
                    | {{ estatusLabel(props.item.status) }}
                td {{ props.item.co_mone || 'US$' }} {{ transform(props.item.tasa ? props.item.total_neto / props.item.tasa : props.item.total_neto) }}
                td
                  v-btn(icon small @click='verDetalle(props.item)')
                    v-icon(color='blue') visibility

  //== Dialog Detalle ==
  v-dialog(v-model='dialog' persistent max-width='1028px')
    v-container(style='background-color:white !important; max-width:1028px;')
      v-flex(xs12)
        v-card(flat)
          v-flex(xs12 md12 sm12 style='margin-top:10px')
            v-layout(row wrap)
              v-flex(xs12 style='display:flex;')
                div(style='display:flex; align-items:center;')
                  img(src='../assets/logo.png' width='auto' height='60')
              v-flex(xs12 style='margin-top:20px; background:#bfbebe; min-height:90px; display:flex; align-items:flex-end;')
                v-layout(row wrap style='line-height:1; padding-bottom:8px;')
                  v-flex(xs6)
                    div(style='padding-left:15px;')
                      p(style='font-weight:500; margin:2px 0;') Nro. Cotización: {{ detalle.doc_num ? detalle.doc_num.trim() : '' }}
                      p(style='font-weight:500; margin:2px 0;') Fecha: {{ detalle.fec_emis | moment('DD/MM/YYYY HH:mm') }}
                      p(style='font-weight:500; margin:2px 0;' v-if='detalle.cliente') Cliente: {{ detalle.cliente }}
                      p(style='font-weight:500; margin:2px 0;' v-if='detalle.vendedor') Vendedor: {{ detalle.vendedor ? detalle.vendedor.trim() : '' }}
                  v-flex(xs6 style='display:flex; justify-content:center; align-items:center;')
                    v-chip(:color='statusColor(detalle.status)' text-color='white')
                      | {{ estatusLabel(detalle.status) }}
              v-flex(xs12 style='height:45px; background:#f3f3f3; display:flex; align-items:center; border-bottom:1px solid #ccc;')
                v-layout(row wrap style='line-height:1;')
                  v-flex(xs4 style='padding-left:15px;')
                    span(style='font-weight:500;') Producto
                  v-flex(xs2)
                    span(style='font-weight:500; display:flex; justify-content:center;') Unidad
                  v-flex(xs2)
                    span(style='font-weight:500; display:flex; justify-content:center;') Cantidad
                  v-flex(xs4)
                    span(style='font-weight:500; display:flex; justify-content:center;') Monto
              v-flex(
                v-for='(item, index) in detalleArticulos'
                :key='index'
                xs12
                v-bind:class="{ 'active': index % 2 !== 0, 'pasive': index === detalleArticulos.length - 1 }"
                style='min-height:45px; background:#f3f3f3; display:flex; align-items:center;'
              )
                v-layout(row wrap style='line-height:1;')
                  v-flex(xs4 style='padding-left:15px;')
                    span(style='font-weight:400; font-size:14px;') {{ item.articulo ? item.articulo.art_des : item.co_art }}
                  v-flex(xs2)
                    span(style='font-weight:400; display:flex; justify-content:center; font-size:14px;') {{ item.co_uni || '-' }}
                  v-flex(xs2)
                    span(style='font-weight:400; display:flex; justify-content:center; font-size:14px;') {{ item.total_art }}
                  v-flex(xs4)
                    span(style='font-weight:400; display:flex; justify-content:center; font-size:14px;') {{ detalle.co_mone || 'US$' }} {{ transform(detalle.tasa ? item.reng_neto / detalle.tasa : item.reng_neto) }}
              v-flex(xs12 style='height:20px; background:#fff;')
              v-flex(xs12 style='height:45px; background:#f3f3f3; display:flex; align-items:center;' v-if='detalle.monto_imp')
                v-layout(row wrap style='line-height:1;')
                  v-flex(xs6)
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span(style='font-weight:500;') SubTotal:
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span {{ detalle.co_mone || 'US$' }} {{ transform(detalle.tasa ? detalle.total_bruto / detalle.tasa : detalle.total_bruto) }}
              v-flex(xs12 style='height:45px; background:#fff; display:flex; align-items:center;' v-if='detalle.monto_imp')
                v-layout(row wrap style='line-height:1;')
                  v-flex(xs6)
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span(style='font-weight:500;') IVA:
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span {{ detalle.co_mone || 'US$' }} {{ transform(detalle.tasa ? detalle.monto_imp / detalle.tasa : detalle.monto_imp) }}
              v-flex(xs12 style='height:45px; background:#f3f3f3; display:flex; align-items:center;')
                v-layout(row wrap style='line-height:1;')
                  v-flex(xs6)
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span(style='font-weight:600;') Total:
                  v-flex(xs3 style='display:flex; justify-content:center;')
                    span(style='font-weight:600;') {{ detalle.co_mone || 'US$' }} {{ transform(detalle.tasa ? detalle.total_neto / detalle.tasa : detalle.total_neto) }}
          v-flex(xs12 sm12 style='margin-top:20px;')
            v-layout(align-start justify-center row wrap fill-height)
              v-btn(style='background:black; border-radius:10px;' @click.native='dialog = false') Salir

  //== Modal espera ==
  v-dialog(v-model='dialog4' persistent max-width='400px')
    v-container(style='max-width:400px; background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-flex(xs12 sm12)
          v-layout(align-start justify-center row wrap fill-height)
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h4.black--text Esperando Respuesta del Servidor..!!
            v-flex(xs12)
              div(style='display:flex; justify-content:center;').text-xs-center
                img(src='../assets/waiting.gif' width='200' height='150')
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h5.black--text Por favor espere...
</template>

<script>
import Api from "@/services/methods";

export default {
  name: "mCotizaciones",
  data: () => ({
    dialog: false,
    dialog4: false,
    loading: false,
    modal: false,
    dates: [],
    filtroStatus: "todos",
    filtroVendedor: "todos",
    busqueda: "",
    resultados: [],
    detalle: {},
    vendedoresOpciones: [{ text: "Todos", value: "todos" }],
    statusOpciones: [
      { text: "Todos", value: "todos" },
      { text: "Creado", value: "0" },
      { text: "Parcialmente Procesado", value: "1" },
      { text: "Procesado", value: "2" },
    ],
    headers: [
      { text: "Nro. Cotización", value: "doc_num", sortable: true },
      { text: "Fecha", value: "fec_emis", sortable: true },
      { text: "Cliente", value: "cliente", sortable: true },
      { text: "Vendedor", value: "vendedor", sortable: true },
      { text: "Estatus", value: "status", sortable: true },
      { text: "Total", value: "total_neto", sortable: true },
      { text: "Acciones", value: "acciones", sortable: false },
    ],
  }),
  computed: {
    dateRangeText() {
      let todos = []
      if (this.dates && this.dates[0]) todos.push(this.formatDate(this.dates[0]))
      if (this.dates && this.dates[1]) todos.push(this.formatDate(this.dates[1]))
      return todos.join(' ~ ')
    },
    detalleArticulos() {
      if (!this.detalle) return [];
      if (this.detalle.renglones && this.detalle.renglones.length > 0) return this.detalle.renglones;
      return [];
    }
  },
  created() {
    this.dates.push(this.$moment().subtract(30, 'd').format('YYYY-MM-DD'))
    this.dates.push(this.$moment().format('YYYY-MM-DD'))
    this.cargarVendedores();
    this.buscar();
  },
  methods: {
    transform(val) {
      if (val == null || val === undefined) return "0,00";
      val = parseFloat(val).toFixed(2).toString().split(".");
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + "," + (val[1] || "00");
    },
    estatusLabel(status) {
      if (!status && status !== 0) return "Desconocido";
      switch (status.toString().trim()) {
        case "0": return "Creado";
        case "1": return "Parcialmente Procesado";
        case "2": return "Procesado";
        default: return status;
      }
    },
    statusColor(status) {
      switch ((status || "").toString().trim()) {
        case "0": return "blue";
        case "1": return "orange";
        case "2": return "green";
        default: return "grey";
      }
    },
    async cargarVendedores() {
      try {
        const res = await Api.get("vendedor");
        const vends = res.data || [];
        this.vendedoresOpciones = [
          { text: "Todos", value: "todos" },
          ...vends.map(v => ({ text: (v.ven_des || v.co_ven || "").trim(), value: (v.co_ven || "").trim() }))
        ];
      } catch (e) {
        console.error("Error cargando vendedores:", e);
      }
    },
    async buscar() {
      this.loading = true;
      try {
        const payload = {
          fechaDesde: this.dates[0] || null,
          fechaHasta: this.dates[1] || this.dates[0] || null,
          status: this.filtroStatus,
          co_ven: this.filtroVendedor,
        };
        const res = await Api.post("cotizacionCom/filtro", payload);
        let data = res.data || [];
        if (this.busqueda.trim()) {
          const q = this.busqueda.trim().toLowerCase();
          data = data.filter(item =>
            (item.doc_num || "").toLowerCase().includes(q) ||
            (item.cliente || "").toLowerCase().includes(q) ||
            (item.vendedor || "").toLowerCase().includes(q)
          );
        }
        this.resultados = data;
      } catch (e) {
        console.error("Error buscando cotizaciones:", e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    limpiar() {
      this.dates = [
        this.$moment().subtract(30, 'd').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ];
      this.filtroStatus = "todos";
      this.filtroVendedor = "todos";
      this.busqueda = "";
      this.buscar();
    },
    verDetalle(item) {
      this.detalle = item;
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #e8e8e8 !important;
}
</style>
